import React from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import './style.css';

const PropertySubmenu = ({ selectedData, onSectionSelect }) => {
    const createPropertySubmenu = (data) => {
        if (!data) return [];

        // Group datapoints by associated_home_name
        const groupedData = data.reduce((acc, datapoint) => {
            const section = datapoint.associated_home_name || 'General Property';
            if (!acc[section]) {
                acc[section] = {
                    items: [],
                    icon: datapoint.associated_home_icon || 'general-property-icon.png'
                };
            }
            acc[section].items.push(datapoint);
            return acc;
        }, {});

        // Convert to array format and sort alphabetically by title
        return Object.entries(groupedData)
            .map(([section, data]) => ({
                id: section.toLowerCase().replace(/\s+/g, '-'),
                title: section,
                icon: data.icon,
                itemCount: data.items.length,
                data: data.items
            }))
            .sort((a, b) => a.title.localeCompare(b.title));
    };

    const homeSections = createPropertySubmenu(selectedData);

    return (
        <div className="home-sections-grid">
            {homeSections.map(section => (
                <button
                    key={section.id}
                    className="home-section-button box-shadow-standard"
                    onClick={() => onSectionSelect(section)}
                >
                    <img
                        src={CreateCloudfrontUrl(section.icon)}
                        alt={section.title}
                        className="home-section-icon"
                    />
                    <div className="section-info">
                        <h3>{section.title}</h3>
                        <span className="item-count">{section.itemCount} items</span>
                    </div>
                </button>
            ))}
        </div>
    );
};

export default PropertySubmenu;
